import React from 'react';
import './CredentialStatusPill.scss';

/**
 * CredentialStatusPill Component
 * A component that displays a status in a pill-shaped container with appropriate styling
 *
 * @component
 * @param {Object} props - Component props
 * @param {('MISSING'|'VERIFIED'|'PENDING'|'REJECTED')} props.status - The status to display
 * @param {string} props.title - The status to display
 * @returns {JSX.Element} A pill-shaped status indicator
 *
 * @example
 * <StatusPill status="VERIFIED" title="CNA"/>
 * <StatusPill status="PENDING" title="RN"/>
 */
const CredentialStatusPill = ({ status, title }) => {
	return <div className={`status-pill ${status.toLowerCase()}`}>{title}</div>;
};

export default CredentialStatusPill;
